import { render, staticRenderFns } from "./deleteAccountInstruction.vue?vue&type=template&id=0f12f76f&scoped=true"
import script from "./deleteAccountInstruction.vue?vue&type=script&lang=js"
export * from "./deleteAccountInstruction.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/style_hdsd.css?vue&type=style&index=0&id=0f12f76f&prod&scoped=true&lang=css&external"
import style1 from "@/assets/css/bootstrap4.3.1.min.css?vue&type=style&index=1&id=0f12f76f&prod&scoped=true&lang=css&external"
import style2 from "./deleteAccountInstruction.vue?vue&type=style&index=2&id=0f12f76f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f12f76f",
  null
  
)

export default component.exports